"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATE = void 0;
const common_1 = require("@finley-technologies/common");
exports.DATE = {
    information: {
        definition: '',
        description: '',
        requiredInputs: { min: 3, max: 3 },
    },
    evaluate: (inputs) => {
        const [year, month, day] = inputs;
        if (typeof year !== 'number') {
            return {
                error: 'Year must be a number',
            };
        }
        if (typeof month !== 'number') {
            return {
                error: 'Month must be a number',
            };
        }
        if (typeof day !== 'number') {
            return {
                error: 'Day must be a number',
            };
        }
        const date = new Date(year, month - 1, day);
        date.setUTCHours(0, 0, 0);
        const iso8601date = date.toISOString().slice(0, 10);
        if (common_1.typeguards.isISO8601Date(iso8601date)) {
            return {
                error: null,
                result: iso8601date,
            };
        }
        return {
            error: 'Invalid date',
        };
    },
};
//# sourceMappingURL=date.js.map